import React from 'react';
import NavbarTwo from '../components/NavbarTwo';
import BannerTen from '../components/BannerTen';
import WhyChooseTwo from '../components/WhyChooseTwo';
import ServiceAreaNine from '../components/ServiceAreaNine';
import WorkProcessEight from '../components/WorkProcessEight';
import TestimonialNine from '../components/TestimonialNine';
import BlogAreaENine from '../components/BlogAreaENine';
import FooterNine from '../components/FooterNine';

const HomeEleven = () => {
  return (
    <>
      {/* NavbarEight */}
      <NavbarTwo />

      {/* BannerTen */}
      <BannerTen />

      {/* WhyChooseTwo */}
      <WhyChooseTwo />

      {/* ServiceAreaNine */}
      <ServiceAreaNine />

      {/* WorkProcessEight */}
      <WorkProcessEight />

      {/* TestimonialNine */}
      <TestimonialNine />

      {/* BlogAreaENine */}
      <BlogAreaENine />

      {/* FooterNine */}
      <FooterNine />
    </>
  );
};

export default HomeEleven;
